import { CellBox } from "./CellBox";
import { EntityChip } from "../EntityChip";
import { useRegistry } from "../../context/RegistryContext";

export type EntityCellField = "source" | "group" | "expenseType";

export type EntityCellProps = {
  field: EntityCellField;
  name: string;
  pending: boolean;
  onClick: () => void;
};

/// An entity-valued cell: the entity's chip when the name resolves, the raw
/// name otherwise (an entity deleted after the row was written).
export const EntityCell = ({
  field,
  name,
  pending,
  onClick,
}: EntityCellProps) => {
  const { getSource, getGroup, getExpenseType } = useRegistry().withHidden;
  const entity =
    field === "source"
      ? getSource(name)
      : field === "group"
        ? getGroup(name)
        : getExpenseType(name);

  return (
    <CellBox pending={pending} onClick={onClick}>
      {entity ? <EntityChip type={field} name={entity.name} iconOnly /> : name}
    </CellBox>
  );
};
